export default __webpack_public_path__ + "media/859e7c43a84f0419c35703f344d3587952d4c232785ae96bab5a8eebb8eef293.svg";